var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11297 4H11.9049C14.3269 4 16.0179 5.66904 16.0179 8.06091V14.9391C16.0179 17.331 14.3269 19 11.9049 19H6.11297C3.69099 19 2 17.331 2 14.9391V8.06091C2 5.66904 3.69099 4 6.11297 4ZM19.958 6.37901C20.397 6.15566 20.912 6.17901 21.331 6.44297C21.75 6.70591 22 7.16277 22 7.66226V15.3384C22 15.8389 21.75 16.2947 21.331 16.5577C21.102 16.7008 20.846 16.7739 20.588 16.7739C20.373 16.7739 20.158 16.7232 19.957 16.6206L18.476 15.8734C17.928 15.5953 17.588 15.0369 17.588 14.4166V8.58307C17.588 7.96175 17.928 7.40337 18.476 7.12723L19.958 6.37901Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.3e8d3be62043b96dba93c16947875047.svg";
export { ForwardRef as ReactComponent };